<template lang="pug">
  .about.page
    main.content
      .row
        .txt.txtCenter.col-8.col-offset-2.col-m-12.col-m-offset-0
          p {{ about.content.main.intro }}
          img(:src="about.content.main.avatar", alt="Foto de Abner Simões").photo
          p {{ about.content.main.text }}

      #companies
        .company.row(v-for="company of about.content.companies")
          .col-3.col-tp-12.logo
            .line
            component(:is="company.logo")
          .col-9.col-tp-8.col-tp-offset-2.col-m-12.col-m-offset-0
            span.date {{ company.date }}
            h4.title {{ company.name }}
            h5.subtitle {{ company.role }}
            p {{ company.text }}

      #navFiles.row
        a(v-for="file of about.content.files", :href="file.url", target="_blank").col-6.col-offset-3.col-tl-8.col-tl-offset-2.col-tp-10.col-tp-offset-1.col-m-12.col-m-offset-0.bt.hl
          component(:is="file.icon").icon
          span {{ file.text }}

    NavFooter(v-bind:nav="about.navFooter")
</template>

<script>
import './style.sass'
import {mapState} from 'vuex'
import NavFooter from '@/components/NavFooter/index.vue'

export default {
  name: 'About',
  components: {
    NavFooter
  },
  data () {
    return {
      baseUrl: process.env.BASE_URL
    }
  },
  computed: {
    ...mapState({
      about: state => state.about
    })
  },
  mounted () {
    this.$store.commit('setLoading', false)
  }
}
</script>